// React Component
import React from 'react';
import TechSphere from '../TechSphere/TechSphere';
const Hero: React.FC = () => {
  return (
    <div className="hero">
      <div className="hero-left">
        <h1 className="hero-title">Welcome to Noha Ibrahim Consultancy</h1>
        <p className="hero-text">
          I am an Interim CTO, technology leader, computational scientist, and senior solution architect with close to two decades of experience in elite academia, industrial R&amp;D, and consulting-led digital transformation. I have worked on cross-functional and multidisciplinary problems, developing models and object-oriented software for analytics, machine learning, and simulation applications.
          <br />
          <br />
          I have nearly 10 years of experience in Oil &amp; Gas, aviation, and water, building digital twins based on hybrid physics, statistical, and machine learning models for condition monitoring, asset integrity, and risk management. My approach is Bayesian by construct, inspired by machine learning methods that obey physics, quantify uncertainty, and express causality. I take special interest in anomaly detection, transparency, and hybrid physics–machine learning as well as human–machine learning.
          <br />
          <br />
          My experience spans corporate digital transformation, strong TDD and agile cultures, and consistently high-quality software, designs, and publications. I am pragmatic, business-oriented, and forward-thinking, always tracking technology trends and fostering productive, human-centered team cultures. I have held several leadership roles and completed leadership training in both academia and industry.
          <br />
          <br />
          I have also completed the Google Cybersecurity Professional Certificate. My mission is to empower your business by integrating complex technologies to drive innovation and growth.
        </p>
      </div>
      <div className="hero-right">
        <TechSphere />
      </div>
    </div>
  );
};

export default Hero;
